module.exports = __webpack_public_path__ + "static/team-image-acaddc72cdc563f010c37b4d24ca821c.jpg";